import StandardNormal from './standard/normal/Index'
import StandardMini from './standard/mini/Index'
import CometMini from './unique/comet/mini/Index'
import { convertCase } from '../core/utils/miscUtils'
import { THEMES } from '../core/appearance/themeRegistry'
import applyAppearance from '../core/appearance/applyAppearance'
import { useSelector } from 'react-redux'
import { INTERNAL_CONSTANTS } from '../core/constants/internalConstants'
import { resolveGameView, GAME_VIEW_STATUS } from '../core/appearance/resolveGameView'
import GameNoticeOverlay from '../components/overlays/GameNoticeOverlay'

const LayoutController = ({ gameCode, theme }) => {
  const LAYOUT_REGISTRY = {
    STANDARD: {
      NORMAL: StandardNormal,
      MINI: StandardMini,
    },
    UNIQUE: {
      COMET: {
        MINI: CometMini,
      },
    },
  }

  const device = useSelector((state) => state.layout.mode)
  const { status, game, mode } = resolveGameView({ gameCode, device })

  // Defensive: GameBootstrap already gates these before the play zone mounts,
  // so in practice we only render here for a resolved game.
  if (status !== GAME_VIEW_STATUS.READY) {
    return <GameNoticeOverlay status={status} gameCode={gameCode} game={game} mode={mode} />
  }

  let Layout

  if (game.layout === INTERNAL_CONSTANTS?.GAME_LAYOUTS?.STANDARD) {
    Layout = LAYOUT_REGISTRY.STANDARD[mode]
  } else if (game.layout === INTERNAL_CONSTANTS?.GAME_LAYOUTS?.UNIQUE) {
    Layout = LAYOUT_REGISTRY.UNIQUE[convertCase({ value: gameCode })][mode]
  }

  const appearance = THEMES[game.layout][gameCode][theme][mode]

  applyAppearance(appearance)

  return <Layout game={game} theme={theme} />
}

export default LayoutController
